// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, role }) => {
  const user = JSON.parse(localStorage.getItem("adminUser"));

  if (!user || user.role !== role) {
    // Redirect to homepage or login if not authorized
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
